module.exports = __webpack_public_path__ + "static/media/hedgehog3-min.c62a0cf4.png";